const LIQUID_ASSET_NAME = /\b(cash|bank|mobile[\s-]*money|momo|mobile wallet|wallet|cash equivalents?|petty cash|till|e-?money)\b/i;
const NON_LIQUID_CASH_NAME = /\b(clearing|in transit|suspense)\b/i;

export function isLiquidAssetAccount(account) {
  if (String(account?.type || "").toLowerCase() !== "asset") return false;
  const name = String(account?.account_name || "");
  if (NON_LIQUID_CASH_NAME.test(name)) return false;
  return account?.control_account_type === "Cash" ||
    account?.control_account_type === "Bank" ||
    LIQUID_ASSET_NAME.test(name);
}

export function isRevenueAccount(account) {
  return String(account?.type || "").toLowerCase() === "revenue";
}